import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { action_global_get_init_message } from '../../../../../store/actions/pages/policy'
import { useSelector } from 'react-redux'
import { useMemo } from 'react'
import Header from "../../fragments/heading/index";
import { FormattedMessage } from 'react-intl'
import { Iconfont } from '../../../../components/icon/iconfont'

const ShippingMore = props => {
    useStyles(classes)
    const pagePolicy = useSelector(state=>state.pagePolicy);

    const messageData = useMemo(() =>{
        if(pagePolicy?.shippingMorePolicy?.message){
            let message = pagePolicy?.shippingMorePolicy?.message;
            return message; 
        }else{
            return null;
        }
    },[pagePolicy?.shippingMorePolicy?.message]);

  
    return <React.Fragment>
        {
            messageData && <React.Fragment>
                <Header 
                centerSlot={<FormattedMessage id="shipping_info" defaultMessage="Shipping Info" />} 
                    rightSlot={
                        <a href={'/user/support'} className={classes.HeaderCart}>
                            <Iconfont className={classes.bigger}>&#xe795;</Iconfont>
                        </a>
                    }
                />

                <div className={classes.Container} dangerouslySetInnerHTML={{ __html: messageData }}></div>
            </React.Fragment>
        }
    </React.Fragment>
}

ShippingMore.fetchData = async (store, params, search, headers) => {
    await store.dispatch(action_global_get_init_message("M1403", "shippingMorePolicy", headers))
}

export default ShippingMore
